import { MenuItem } from "@mui/material";
import { ButtonNavbar, Menu } from "./MenuService";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { checkLanguage } from "utility";
import ReactGA from "react-ga4";

const MenuLanguage = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const convertMapLang = (lang) => {
    switch (checkLanguage(lang)) {
      case "en":
        return "English";
      case "th":
        return "ไทย";
      case "vi":
        return "Tiếng Việt";
    }
  };
  return (
    <>
      <ButtonNavbar
        endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
        onClick={handleClick}
      >
        {convertMapLang(i18n.language)}
      </ButtonNavbar>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem
          onClick={() => {
            i18n.changeLanguage("en");
            window.location.reload();
            ReactGA.event("language", {
              component: "navbar",
              event_value: "en"
            });
          }}
          selected={i18n.language === "en"}
        >
          English
        </MenuItem>
        <MenuItem
          selected={i18n.language === "th"}
          onClick={() => {
            i18n.changeLanguage("th");
            window.location.reload();
            ReactGA.event("language", {
              component: "navbar",
              event_value: "th"
            });
          }}
        >
          ไทย
        </MenuItem>
        <MenuItem
          selected={i18n.language === "vi"}
          onClick={() => {
            i18n.changeLanguage("vi");
            window.location.reload();
            ReactGA.event("language", {
              component: "navbar",
              event_value: "vi"
            });
          }}
        >
          Tiếng Việt
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuLanguage;
